import { render, staticRenderFns } from "./Names.vue?vue&type=template&id=84a4a9aa&scoped=true"
import script from "./Names.vue?vue&type=script&lang=js"
export * from "./Names.vue?vue&type=script&lang=js"
import style0 from "./Names.vue?vue&type=style&index=0&id=84a4a9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a4a9aa",
  null
  
)

export default component.exports